import { statuses, base } from '../../../../config'
import RGL, { WidthProvider } from "react-grid-layout"
const ReactGridLayout = WidthProvider(RGL)
import { objCleaner } from '../../../helpers'
import Job from '../../../components/Job'
import React, { Component } from 'react'
import Rebase  from 're-base'
import * as _ from 'lodash'
import './StatusBoard.scss'


class StatusBoard extends Component {

    _delete (sheetId) {
      base.remove(`user_details/${this.props.uid}/sheets/${sheetId}`)
      base.remove(`user_details/${this.props.uid}/jobs/${sheetId}`)
    }

    onLayoutChange(layout, oldItem, newItem, placeholder, e, element) {
      var job_key = this.refs.board.props.layout.filter((el) => {return el.i === oldItem.i})[0].key
      var job_moved_index = layout.filter((el) => {return el.i === oldItem.i})[0].x
      base.post(`user_details/${this.props.uid}/jobs/${job_key}/selected_status`, {
        data: statuses[job_moved_index]
      })
    }

    render() {

        let layout = []
        let render = []

        const groups = _.groupBy(this.props.jobs, job => {
          return job.selected_status.col
        })

        Object.keys(groups).map((key, index1) => {
          groups[key].map((job, index2) => {
            layout.push({i: job.key, status: job.status, key: job.key, x: job.selected_status.col-1, y: index1, w: 1, h: 1})
          })
        })

        layout.map((item, index) => {
          const job = this.props.jobs.filter((el) => {return el.key === item.key})[0]
          render.push(
            <div className={`task`} key={job.key.toString()}>
              <Job view_job class='col-sm-' delete={this._delete} id={`${job.key}`} uid={this.props.uid} job={job} />
            </div>
          )
        })

        return (
            <div className='satus-board'>

                <div className='panel'>
                  <div className='panel-heading'>
                    Drag your job into the status
                  </div>
                  <div className='panel-body'>
                    <div className='row'>
                      <div className='col-sm-3'>
                        <label className='m-t-0 m-b-sm'>Quoted</label>
                      </div>
                      <div className='col-sm-3'>
                        <label className='m-t-0 m-b-sm'>Confirmed</label>
                      </div>
                      <div className='col-sm-3'>
                        <label className='m-t-0 m-b-sm'>Invoiced</label>
                      </div>
                      <div className='col-sm-3'>
                        <label className='m-t-0 m-b-sm'>Paid</label>
                      </div>
                    </div>
                    {this.props.jobs.length > 0 &&
                       <ReactGridLayout cols={4} rowHeight={180} ref="board" containerPadding={[0, 0]} margin={[16, 16]} isResizable={false} onDragStop={this.onLayoutChange.bind(this)} className="layout" layout={layout}>
                         {render}
                      </ReactGridLayout>
                    }
                  </div>
                </div>

            </div>
        )
    }
}

export default StatusBoard



// WEBPACK FOOTER //
// ./src/views/pages/Jobs/StatusBoard/index.js